import React, { useCallback, useEffect, useState } from 'react'
import cx from 'classnames'
import styles from './Carousel.module.css'

const Carousel: React.FC<{
    items: React.ReactNode[]
    time: number
    classes?: string
}> = ({ items, time, classes }) => {
    const [current, setCurrent] = useState<number>(0)

    const infiniteScroll = useCallback(() => {
        if (items.length <= 1) return

        if (current === items.length - 1) return setCurrent(0)
        else return setCurrent((prev) => prev + 1)
    }, [current, items])

    useEffect(() => {
        const interval = setInterval(() => {
            infiniteScroll()
        }, time)

        return () => clearInterval(interval)
    }, [infiniteScroll, time])

    return (
        <div className={cx(styles['carousel-container'], classes)}>
            {items.map((item, index) => {
                return (
                    <div
                        className={cx(styles['carousel-item'])}
                        key={index}
                        style={{
                            transform:
                                current === 0
                                    ? `translate(-${current * 100}%)`
                                    : `translate(calc(-${current * 100}% - 1rem))`,
                        }}
                    >
                        {item}
                    </div>
                )
            })}
        </div>
    )
}

export default Carousel
